<template>
    <Teleport to="body">
        <Transition name="fade">
            <div
                v-if="modelValue"
                class="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
                @keyup.esc="closeModal"
                @click="handleBackdropClick"
            >
                <div
                    class="relative flex h-full w-full items-center justify-center p-4 md:p-8 lg:p-12"
                    @click="handleBackdropClick"
                >
                    <!-- Close button -->
                    <button
                        class="fixed top-4 right-4 z-10 grid cursor-pointer place-content-center gap-2 p-4 text-center text-white"
                        @click="closeModal"
                    >
                        <DIcon
                            icon="ph:x"
                            size="w-6 h-6"
                            class="m-auto"
                        />
                        <span class="font-ux text-xs">Close</span>
                    </button>

                    <!-- Video player -->
                    <VideoPlayer
                        v-if="videoData?.src && modelValue"
                        ref="modalVideoPlayer"
                        :is-modal="true"
                        :options="{
                            src: videoData.src,
                            poster: videoData.poster,
                            autoplay: false,
                            loop: true,
                            controls: false,
                            displayControls: true,
                            muted: false,
                            ...videoData.options,
                        }"
                        class="h-auto! w-full! lg:h-full! lg:max-h-[75vh] lg:w-auto! lg:max-w-[90vw]"
                        @click.stop
                    />
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
    import { DIcon } from '@digistorm/spark'

    const _props = defineProps({
        videoData: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: Boolean,
            default: false,
        },
    })

    const emit = defineEmits(['update:modelValue'])
    const modalVideoPlayer = ref(null)

    const closeModal = () => {
        if (modalVideoPlayer.value?.player) {
            modalVideoPlayer.value.player.pause()
        }

        emit('update:modelValue', false)
    }

    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            closeModal()
        }
    }

    defineExpose({
        modalVideoPlayer,
    })

    onMounted(() => {
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                closeModal()
            }
        }

        document.addEventListener('keydown', handleEscapeKey)

        onUnmounted(() => {
            document.removeEventListener('keydown', handleEscapeKey)
        })
    })
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }
</style>
